export const environment = {
  production: true,
  cdnHost: 'https://cdn.localhost/',
  defaultApp: 'cf-shell',
};
